import { render } from "./WNAbnormalCallListCY.vue?vue&type=template&id=16ad2ed5&scoped=true"
import script from "./WNAbnormalCallListCY.vue?vue&type=script&lang=js"
export * from "./WNAbnormalCallListCY.vue?vue&type=script&lang=js"

import "./WNAbnormalCallListCY.vue?vue&type=style&index=0&id=16ad2ed5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-16ad2ed5"

export default script